/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './headline.scss';

class Headline extends Component {
  render() {
    const { text, as, level, id, className } = this.props;

    const Tag = as;
    const levelClass = `bt-headline bt-headline--${['one', 'two', 'three'][level - 1]}`;
    const fullClassName = `${levelClass}${className ? ` ${className}` : ''}`;

    return (
      <Tag {...(id ? { id } : {})} className={fullClassName}>
        {text}
      </Tag>
    );
  }
}

Headline.propTypes = {
  text: PropTypes.string,
  as: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'div', 'span', 'p']),
  level: PropTypes.oneOf([1, 2, 3]),
  id: PropTypes.string,
  className: PropTypes.string,
};

Headline.defaultProps = {
  text: '',
  as: 'h1',
  level: 1,
  id: '',
  className: '',
};

export default Headline;
